import React, { Component } from "react";
import Yup from "yup";
import { func, shape, bool, string, number, arrayOf } from "prop-types";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Col from "react-bootstrap/lib/Col";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";

import I18n from "pages/_components/I18n";
import Credential from "pages/_components/fields/credentials/Credential";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import * as accountUtils from "util/accounts";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import Heading from "pages/_components/Heading";
import { selectors as debinSelectors, actions as debinActions } from "reducers/debin";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as loginActions } from "reducers/login";
import PageLoading from "pages/_components/PageLoading";
import { resizableRoute } from "pages/_components/Resizable";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Notification from "pages/_components/Notification";
import isTokenActive from "util/token";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

const FORM_ID = "fixedTermAcceptance.decline.summary";
class DeclineFixedTermConfirm extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        debinDetail: shape({}).isRequired,
        loggedUser: shape({
            accessToken: string,
            defaultAvatarId: string,
            email: string,
            previousLoginInfo: arrayOf(
                shape({
                    city: string,
                    country: string,
                    date: string,
                    idUser: string,
                    ip: string,
                    latitude: number,
                    longitude: number,
                }),
            ),
            securitySeal: number,
            userFullName: string,
        }),
        accounts: shape({}),
        fetchingAccounts: bool.isRequired,
        accountName: string.isRequired,
        isSubmitting: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        loggedUser: null,
        accounts: null,
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, loggedUser, accounts } = this.props;
        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, debinDetail } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.debinDetail?.id !== debinDetail?.id)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, debinDetail } = this.props;
        if (!debinDetail?.id) {
            return;
        }
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["debin"],
            titleKey: "fixedTermAcceptance.decline.header.title",
            goBackPath: `/fixedTermAcceptance/detail/${debinDetail.id}`,
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    handleClose = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    handleDownload = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.downloadDocumentRequest({ format: "pdf" }));
    };

    getTitle = () => (
        <>
            <div className="view-title data-wrapper-flex">
                <h1 style={{ marginRight: "1rem" }}>{i18nUtils.get("fixedTermAcceptance.decline.header.title")}</h1>
            </div>
            <p>{i18nUtils.get("fixedTermAcceptance.decline.confirm.header.subtitle")}</p>
        </>
    );

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ margin: "0.2rem" }}>{i18nUtils.get("fixedTermAcceptance.decline.header.title")}</h1>
        </div>
    );

    render() {
        const {
            isDesktop,
            fetchingAccounts,
            accounts,
            debinDetail,
            accountName,
            isSubmitting,
            embeddedInV3Shell,
        } = this.props;

        if (!debinDetail) {
            return <></>;
        }

        const continueButton = (
            <Col className="col col-12" lg={12} xl={12} md={12} sm={12}>
                <Button
                    type="submit"
                    bsStyle="primary"
                    label="global.confirm"
                    image="images/arrowRight.svg"
                    imageStyle="mr-2"
                    className="text-capitalize"
                    loading={isSubmitting}
                />
            </Col>
        );

        const credentials = (
            <>
                {!isTokenActive(!isDesktop) ? (
                    <div className="admin-content-center">
                        <I18n id="transfer.summary.confirm.label" />
                    </div>
                ) : (
                    <div className="admin-content-center pb-3">
                        <I18n
                            id="confirmation.withoutotp.text"
                            component="p"
                            componentProps={{ className: "confirmation__text-without-otp" }}
                        />
                    </div>
                )}
                <div className="admin-content-center">
                    <Field
                        placeholderText={i18nUtils.get(`confirmation.otp.placeholder`)}
                        name="otp"
                        type="otp"
                        idForm={FORM_ID}
                        component={Credential}
                    />
                </div>
            </>
        );

        const {
            buyerDetail,
            concept,
            description,
            expirationDate,
            id,
            sellerDetail,
            amount: { currency, quantity },
            amount,
            reference,
        } = debinDetail;

        const loggedUserAccount = accountUtils.getUserAccount(accounts, buyerDetail?.cbu);

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="debin" />}
                {!(embeddedInV3Shell && !isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            onClose={isDesktop && this.handleClose}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                        />
                        {isDesktop && <Head centerElement={this.getTitle} />}
                    </div>
                )}
                <PageLoading loading={fetchingAccounts}>
                    <MainContainer>
                        <Form className="above-the-fold">
                            {embeddedInV3Shell && !isDesktop && (
                                <div className="admin-content-center d-flex justify-content-center">
                                    <p className="py-3 px-4 f-size-35 mb-0">
                                        {i18nUtils.get("fixedTermAcceptance.decline.confirm.header.subtitle")}
                                    </p>
                                </div>
                            )}
                            <Container
                                className=" flex-grow container-white with-margin"
                                style={{ textTransform: "uppercase" }}>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data data-wrapper"
                                        label="fixedTermAcceptance.accept.table.header.debitAccount"
                                        data={accountName || <p> - </p>}
                                    />
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        data={
                                            loggedUserAccount ? (
                                                <div style={{ display: "flex" }}>
                                                    <span style={{ marginRight: "0.5rem" }}>
                                                        {i18nUtils.get("accounts.availableBalance")}
                                                    </span>
                                                    <FormattedAmount
                                                        currency={loggedUserAccount.currency}
                                                        quantity={loggedUserAccount.balance}
                                                    />
                                                </div>
                                            ) : (
                                                <p> - </p>
                                            )
                                        }
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data data-wrapper"
                                        label="payments.debin.detail.table.header.concept"
                                        data={concept ? i18nUtils.get(`transfers.concept.${concept}`) : <p> - </p>}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data data-wrapper"
                                        label="payments.debin.detail.table.header.description"
                                        data={description || <p> - </p>}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data data-wrapper"
                                        label="payments.debin.detail.table.header.expirationDate"
                                        data={
                                            expirationDate ? (
                                                <FormattedDate date={expirationDate} dateFormat="dd/MM/yyyy" showTime />
                                            ) : (
                                                <p> - </p>
                                            )
                                        }
                                    />
                                </Col>
                            </Container>
                            <Container
                                className=" flex-grow container-white with-margin"
                                style={{ textTransform: "uppercase" }}>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        label="fixedTermAcceptance.accept.table.header.id"
                                        data={id}
                                    />
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        label="fixedTermAcceptance.accept.table.header.creditAccount"
                                        data={accountUtils.getAccountNumber(sellerDetail.cbu)}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        label="payments.debin.detail.table.header.sender"
                                        data={sellerDetail.titular || <span> - </span>}
                                    />
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        label="fixedTermAcceptance.accept.table.header.cbu"
                                        data={sellerDetail.cbu}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        data={
                                            (
                                                <div style={{ display: "flex" }}>
                                                    <span className="data-label">
                                                        {i18nUtils.get(
                                                            "fixedTermAcceptance.accept.table.header.documentType",
                                                        )}
                                                    </span>
                                                    <span style={{ marginRight: "0.5rem" }}>
                                                        {sellerDetail.documentType}
                                                    </span>
                                                    <span>{sellerDetail.documentNumber}</span>
                                                </div>
                                            ) || <p> - </p>
                                        }
                                    />
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        label="fixedTermAcceptance.accept.table.header.bank"
                                        data={sellerDetail.bank ? sellerDetail.bank : <p> - </p>}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        data={
                                            amount ? (
                                                <div style={{ display: "flex" }}>
                                                    <span className="data-label">
                                                        {i18nUtils.get("payments.debin.detail.table.header.amount")}
                                                    </span>
                                                    <FormattedAmount currency={currency} quantity={quantity} />
                                                </div>
                                            ) : (
                                                <p> - </p>
                                            )
                                        }
                                    />
                                    <Heading.DataGroup
                                        containerClassName="transfer-data"
                                        label="payments.debin.detail.table.header.reference"
                                        data={reference || <span> - </span>}
                                    />
                                </Col>
                            </Container>
                            <Container
                                className={`flex-grow align-items-center container-white ${!isDesktop ? "mb-0" : ""}`}
                                gridClassName="form-content">
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    {credentials}
                                    {continueButton}
                                </Col>
                            </Container>
                        </Form>
                    </MainContainer>
                </PageLoading>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    debinDetail: debinSelectors.getDebinDetail(state),
    accountName: debinSelectors.getAccountName(state),
    loggedUser: sessionSelectors.getUser(state),
    fetchingAccounts: accountsSelectors.getFetching(state),
    accounts: accountsSelectors.getAccounts(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ otp: "" }),
        validationSchema: () =>
            Yup.object().shape({
                otp: Yup.string().required(i18nUtils.get(`${FORM_ID}.otp.error.required`)),
            }),
        handleSubmit: ({ otp }, formikBag) => {
            const { dispatch, debinDetail, accounts, loggedUser } = formikBag.props;

            const {
                id: idDebin,
                amount: { currency, quantity: amount },
                buyerDetail,
            } = debinDetail;

            const loggedUserAccount = accountUtils.getUserAccount(accounts, buyerDetail?.cbu);
            dispatch(
                debinActions.declineFixedTermRequestSend(
                    currency,
                    amount,
                    idDebin,
                    otp,
                    loggedUserAccount,
                    loggedUser.userId,
                    formikBag,
                ),
            );
        },
    }),
    resizableRoute,
)(DeclineFixedTermConfirm);
